<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Selecione o serviço</p>
    <v-autocomplete
      outlined
      dense
      label="Selecione o Criador"
      v-model="filter.person_id"
      item-text="name"
      item-value="id"
      :items="creators"
      no-data-text="Nenhum Resultado"
      @change="$emit('get-farms', filter.person_id)"
      class="form-panel__field"
    ></v-autocomplete>

    <v-autocomplete
      outlined
      dense
      label="Selecione a Fazenda"
      v-model="filter.farm_id"
      item-text="name"
      item-value="id"
      :items="farms"
      no-data-text="Nenhum Resultado"
      class="form-panel__field"
      @change="$emit('get-services', {farm: filter.farm_id})"
      :disabled="filter.person_id ? false : true"
    ></v-autocomplete>

    <v-autocomplete
      outlined
      dense
      v-model="filter.service_id"
      item-text="title"
      item-value="id"
      :items="computedServices"
      no-data-text="Nenhum Resultado"
      label="Selecione o Serviço"
      class="form-panel__field form-panel__field--wide"
      @change="$emit('get-results', {service_id:filter.service_id})"
    ></v-autocomplete>
  </div>
</template>

<script>
import helpers from "@/mixins/helpers";
export default {
  name: "TheFilters",
  mixins: [helpers],
  props: {
    creators: Array,
    farms: Array,
    services: Array
  },
  data: () => ({
    filter: {}
  }),
  computed: {
    computedServices() {
      return this.services.filter(a => a.date_close.trim().length > 0).map(service => ({...service, title: this.parseDate(service.date) + " - Serviço #" + service.code}));
    }
  },
  watch: {
    /* services: {
      deep: true,
      handler(val) {
        this.filter.service_id = val[1].id;
        this.$emit("get-results", {service_id:this.filter.service_id});  
      }
    }, */
    filter: {
      deep: true,
      handler(val) {
        this.$emit("update-filter", val);
      }
    }
  }
}
</script>

<style>

</style>